export const CELL_SIZE = 30;
export const MAP_WIDTH = 9;
export const MAP_HEIGHT = 9;